import React from "react";
import MilestoneTable from "./components/MilestoneTable";

function Tables() {
  return <MilestoneTable />;
}

export default Tables;
